import _ from 'lodash';

export default class Product {
  constructor(data) {
    this.id = _.get(data, 'id', '');
    this.codeSupplier = _.get(data, 'codeSupplier', '');
    this.name = _.get(data, 'name', '');
    this.packaging = _.get(data, 'packaging', '');
    this.unit = _.get(data, 'unit', '');
    this.supplier = _.get(data, 'supplier', '');
    this.price = _.get(data, 'price', '');
    this.uc = _.get(data, 'uc', '');
    this.sharedMarket = _.get(data, 'sharedMarket', false);
    this.conditionning = _.get(data, 'conditionning', 1);
    this.emergency = _.get(data, 'emergency', false);
    this.ean = _.get(data, 'ean', '');
    this.tag = _.get(data, 'tag', '');
    this.pic = `${this.codeSupplier}_${this.id}`;
  }
}
